var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "div",
      {
        staticClass: "modal custom",
        attrs: { id: "feedbackPopup", role: "dialog" },
      },
      [
        _c("div", { staticClass: "modal-dialog request-modal" }, [
          _c("div", { staticClass: "modal-content" }, [
            _c("div", { staticClass: "modal-body" }, [
              _c(
                "button",
                {
                  staticClass: "close",
                  attrs: { type: "button", "data-dismiss": "modal" },
                },
                [_vm._v("×")]
              ),
              _c("div", { staticClass: "p-confirm" }, [
                _vm._m(0),
                _c("div", [
                  _vm._v(
                    "RAMS is strongly committed to providing you with the finest customer experience possible. We would appreciate your feedback about our services. If you would be willing to spend a couple of minutes to share your insight on our performance,"
                  ),
                ]),
                _c("div", [
                  _vm._v(" please click "),
                  _c(
                    "a",
                    {
                      staticClass: "feedback-link",
                      attrs: {
                        id: "feedback_link",
                        href: _vm.feedbackurl,
                        target: "_blank",
                      },
                      on: { click: _vm.closePopup },
                    },
                    [_vm._v("here.")]
                  ),
                ]),
                _c("div", { staticClass: "footer-message" }, [
                  _vm._v(
                    "(Page would automatically redirect within " +
                      _vm._s(_vm.timer) +
                      " seconds)"
                  ),
                ]),
              ]),
            ]),
          ]),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", [
      _c("div", { staticClass: "check_feedback" }, [
        _c("i", {
          staticClass: "fa fa-thumbs-up",
          attrs: { "aria-hidden": "true" },
        }),
      ]),
      _c("h3", { staticClass: "confirm_title" }, [
        _vm._v("We would love to hear from you"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }